import Tabs from "components/BaseWidgets/tab";
import "./style.scss";
import { ConnectCall, ConnectChat, ConnectRequest } from "assets/icons";
import TabFilter from "./components/TabFilter";
import { FilterData } from "./helper";
import { useState } from "react";
import Chats from "./components/Chats";
import Calls from "./components/Calls";
import Requests from "./components/Requests";
import { useUserRequestList } from "hooks/api/useUserRequestList";
import { useMessageRequestList } from "hooks/api/useMessageRequestList";

function Connect() {
  const [active, setActive] = useState("1");
  const [chatFilters, setChatFilters] = useState({
    page: 1,
    limit: 20,
    list_type: null,
  });
  const [requestFilters, setRequestFilters] = useState({
    page: 1,
    limit: 20,
    list_type: null,
  });
  const activeFilters = active === "3" ? requestFilters : chatFilters;
  const { data, refetch } = useUserRequestList(requestFilters);

  const requestCount =
    data?.list?.filter((item) => item.status === 1)?.length || 0;
  length;
  const tabItems = [
    {
      key: "1",
      label: (
        <span className="flex items-center gap-1-5">
          <ConnectChat />
          Chats
        </span>
      ),
      children: <Chats profileFilters={chatFilters.list_type} />,
    },
    //hide calls tab for now
    // {
    //   key: "2",
    //   label: (
    //     <span className="flex items-center gap-1-5">
    //       <ConnectCall />
    //       Calls
    //     </span>
    //   ),
    //   children: <Calls />,
    // },
    {
      key: "3",
      label: (
        <span className="tab-label">
          <span className="tab-text">
            <ConnectRequest />
            Requests
          </span>

          {typeof requestCount === "number" && requestCount > 0 && (
            <span className="request-badge">{requestCount}</span>
          )}
        </span>
      ),
      children: <Requests filters={requestFilters} />,
    },
  ];
  const handleFilter = (selectedItems) => {
    console.log("MULTI SELECT RESULT:", selectedItems);

    // Remove ALL options where value is null
    const values = selectedItems.map((it) => it.value).filter(Boolean);

    if (active === "1") {
      setChatFilters({ list_type: values.length ? values : null });
    }

    if (active === "3") {
      setRequestFilters({
        page: 1,
        limit: 20,
        list_type: values.length ? values : null,
      });
    }
  };

  const getFilterConfig = (key) => {
    switch (key) {
      case "1":
        return { data: FilterData.chats };
      case "2":
        return { data: FilterData.calls, isAccordion: true };
      case "3":
        return { data: FilterData.requests };
      default:
        return { data: [] };
    }
  };

  // return (
  //   <div className="container coming-soon">
  //     <div className="notification-modal">
  //       <div class="ant-modal-content">
  //         <div class="ant-modal-body">
  //           <h2 class="modal-heading">Coming soon!</h2>
  //           <div class="notification-content flex flex-col items-center text-center">
  //             <p class="modal-text">
  //               Thanks for your patience while we prepare this experience for
  //               you.
  //             </p>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );

  return (
    <div className="container connect-container">
      <Tabs
        activeKey={active}
        onChange={(key) => setActive(key)}
        variant="primary"
        className="connect-tab"
        position="left"
        items={tabItems}
        extraContent={{
          right: (
            <TabFilter
              key={active}
              {...getFilterConfig(active)}
              onChange={handleFilter}
            />
          ),
        }}
      />
    </div>
  );
}

export default Connect;
